import { render } from "./ObservacoesPedidosCanceladosLiquidados.vue?vue&type=template&id=cacdc2c6&scoped=true"
import script from "./ObservacoesPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./ObservacoesPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./ObservacoesPedidosCanceladosLiquidados.vue?vue&type=style&index=0&id=cacdc2c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacdc2c6"]])

export default __exports__